// MODULES
import React from "react";
import PropTypes from "prop-types";

// CLASSES
import Partner from "@classes/Partner";
import Session from "@classes/Session";
import {createClassName, localeNumber} from "@helpers/utils";
import fulfillmentCheck from "./ProductPurchase.fulfillment";
import api from "../../../../../helpers/api";
import EditableField from "../../../components/EditableField/EditableField";
import NumberField from "../../../components/NumberField/NumberField";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";
import OptionsList from "../../../components/OptionsList/OptionsList";
import FieldsCollection from "../../../../../components/FieldsCollection/FieldsCollection";
import * as CobHelpers from "../../../Cob.helpers";
import AppConfig from "../../../../../classes/AppConfig";

export default class ProductPurchase extends React.PureComponent {

	static minimumAmountSingleDeposit = 100000;

	static propTypes = {
		id: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		partner: PropTypes.instanceOf(Partner).isRequired,
		session: PropTypes.instanceOf(Session).isRequired,
		sectionNumber: PropTypes.number.isRequired,
		number: PropTypes.number.isRequired,
		prevState: PropTypes.object,
		onChange: PropTypes.func.isRequired
	};

	static companyExclusive = false;
	static privateExclusive = false;

	state = _getInitialState.call(this);

	async componentDidMount() {
		const {app, partner} = this.props;

		/**
		 * Fetch the list of products that are available for purchase
		 */
		try {
			console.log("Loading products for ProductPurchase...");
			const newStateProps = {};
			newStateProps.products = await api("/case/products", {
				productVariant: "aif",
				authToken: this.authToken
			});
			this.setState(newStateProps);
		}
		catch (e) {
			console.log(e);
		}

		/**
		 * Purchasing product is optional so mark is green right from the start
		 */
		const fulfilledViewsById = {...app.fulfilledViewsById};
		for (let i = 0; i < partner.sections.length; i++) {
			if (partner.sections[i][0] === "productpurchase2-alfakraft") {
				fulfilledViewsById["productpurchase2-alfakraft"] = true;
			}
			else if (partner.sections[i][0] === "productpurchase-alfakraft") {
				fulfilledViewsById["productpurchase-alfakraft"] = true;
			}
		}

		this.props.actions.setAppState({fulfilledViewsById});
	}

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}
	}

	render() {

		const {state} = this;
		const {session} = this.props;

		const classes = createClassName("Cob-ProductPurchase-Alfakraft", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled
		});

		const textClassDeposit = createClassName("products", {
			"expanded": state.fields.customer_product_deposit_checkbox.checked
		});

		const frfLogoUrl = AppConfig.get("apiUrl") + "/partner/img?filename=alfa-frf.png";

		let fundAmountForDisplay;
		if (state.fields.investedamount >= 0) {
			if (state.fields.investedamount === 0) {
				fundAmountForDisplay = "0 SEK";
			}
			else {
				fundAmountForDisplay = localeNumber(state.fields.investedamount, 0) + " SEK";
			}
		}
		else {
			fundAmountForDisplay = "Felaktigt belopp";
		}

		return (
			<div className={classes}>
				<h2>Fondsparande i AIF-fond: Fastighetsräntefonden</h2>

				<div style={{
					position: "absolute",
					top: "20px",
					left: "-170px",
					fontSize: "12px",
					color: "#FFF"
				}}>
					<div style={{width: "120px", textAlign: "center", fontWeight: "bold"}}>
						<img src={frfLogoUrl} alt={""} style={{
							width: "120px",
							height: "120px",
							border: "1px solid #CCC",
							margin: "0 0 5px 0"
						}}/>
						Fastighetsräntefonden
					</div>
				</div>

				<p style={{margin: "0 0 10px 0", maxWidth: "620px", fontSize: "14px"}}>
					Tecknar du Fastighetsräntefonden via samarbetet med Nord betalar du enbart 1,2% i avgift
					istället för ordinarie 1,6% i fast förvaltningsavgift. Rabatten sätts in på din depå varje kvartal.
					Minsta insättning 100 000 SEK. Om du har fyllt i ovanstående autogiromedgivande kan vi dra pengar
					automatiskt från ditt bankkonto när det är godkänt hos Bankgirocentralen. Annars måste du se till
					att likviden finns på din depå i slutet av månaden.<br/><br/>
					<strong>OBS!</strong> för att teckna AIF-fonden Fastighetsräntefonden kommer du att behöva
					signera två olika avtal. Det första är för att öppna själva ISK:n/depån, sedan kommer automatiskt
					teckningsanmälan för fonden upp. Kom ihåg att inte stänga ned browserfönstret.
				</p>

				{session.isCompany && (
					<p>
						För att kunna investera i AIF-fonden Fastighetsräntefonden måste LEI-kod innehas och anges under kunduppgifter.
					</p>
				)}

				<div className="payments">
					<div className="selection">
						<CheckboxWithName
							label="Jag vill göra en engånginsättning till Fastighetsräntefonden"
							name="checkbox_aif_single"
							value={(state.fields.customer_product_deposit_checkbox && state.fields.customer_product_deposit_checkbox.checked) ? "yes" : "no"}
							checked={state.fields.customer_product_deposit_checkbox.checked}
							onChange={this._onCheckboxChange}
						/>
					</div>

					<div className={textClassDeposit}>
						<div className="amountField" style={{width: "600px"}}>
							<EditableField
								name="investedamount"
								label="Belopp"
								className="amount"
								value={state.fields.customer_product_deposit_checkbox.checked ? state.fields.investedamount : ""}
								Component={NumberField}
								onChange={this._onFieldChange}
								onBlur={this._onFieldBlur}/>
							<span>(min. 100 000 SEK)</span>

							<div style={{display: "block", textAlign: "right", flex: "2", fontSize: "12px"}}>
								<strong style={{display: "block", padding: "0 0 4px 0"}}>Belopp att investera</strong>
								{fundAmountForDisplay}
							</div>
							<input type="hidden" name="investedamount"
								   value={state.fields.customer_product_deposit_checkbox.checked ? state.fields.investedamount : ""}/>
							<input type="hidden" name="totalamount"
								   value={state.fields.customer_product_deposit_checkbox.checked ? state.fields.investedamount : ""}/>
						</div>

						{this.props.app.isAutogiroApproved && state.fields.customer_product_deposit_checkbox.checked && (
							<div className="autogiro-approval">
								<FieldsCollection
									fields={[
										{
											render: (
												<OptionsList
													type="radio"
													orientation="horizontal"
													name="customer_product_autogiro"
													description="Använd autogiro för engångsinsättning"
													options={state.fields.customer_product_autogiro.options}
													onChange={this._onChangeAutogiroSelect}
												/>
											)
										}
									]}
								/>
							</div>
						)}

						<input type="hidden" name="fastighetsrantefonden_deposit_time" value="now"/>
					</div>

				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) => {
		if (name === "investedamount") {
			return value.length > 0 && value >= ProductPurchase.minimumAmountSingleDeposit;
		}
		return value.length > 0;
	};

	_onChangeAutogiroSelect = ({type, name}, option, index) => {
		name = name || option.name;
		const newOptions = [...this.state.fields[name].options].map((o, i) => {
			if (i === index) {
				return option;
			}
			else {
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});


		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => fulfillmentCheck(this.props, this.state));
	};

	_onFieldChange = (name, value) => {
		/**
		 * For the single deposit and monthly savings field treat zero as if the value has not been entered
		 */
		if (name === 'investedamount' && value === "0") {
			value = "";
		}

		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onCheckboxChange = (name, checked) => {
		this.setState({
			fields: {
				...this.state.fields,
				customer_product_deposit_checkbox: {
					checked: checked
				}
			}
		}, () => {
			this.props.actions.setAppState({
				isProductClassBSelected: checked
			});
		});
	};
}


// PRIVATE FUNCTIONS
function _getInitialState() {
	const {props} = this;
	if (props.prevState) {
		return {...props.prevState};
	}

	return {
		fields: {
			customer_product_deposit_checkbox: {
				checked: false
			},
			customer_product_autogiro: {
				options: [
					{label: "Ja", value: "yes", checked: true},
					{label: "Nej", value: "no", checked: false}
				]
			},
			investedamount: ""
		},
		validFields: {}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/ProductPurchase/alfakraft/ProductPurchase.js